module.exports= {
    zhuchang: [
        '全部',
        '正康育肥场', 
        '平望母猪场', 
        '下水碓育肥场', 
        '三亩田种猪场', 
        '下各育肥场',
        '瓦垚头母猪场',
        '莲花育肥场',
        '张村母猪场',
        '横路育肥场',
        '里塘母猪场',
        '苍坑育肥场',
        '天台育肥场',
        '同壮一体化猪场',
        '浦江一体化猪场',
        '东阳一体化猪场',
        '乐清一体化猪场',
        '瑞溪母猪场',
        '百凤林育肥场',
        '瀚荣农业',
        '金雪珍代养场',
        '余金泉代养场',
        '金雪珍代养场',
        '余金泉代养场',
        '臧鹏飞代养场',
        '方新华代养场',
        '姚勇汉代养场',
        '胡海英代养场',
        '陈细倪代养场',
        '向焱初代养场',
        '彭爱兰代养场',
        '周文雨代养场',
        '余玲玲代养场',
        '陈丹代养场',
        '徐珺珺代养场',
        '黄光明代养场',
        '张顺风代养场',
        '尚喜峰代养场',
        '乔迟来代养场',
        '彭高山代养场',
        '江海英代养场',
        '林德文代养场',
        '程雨忠代养场',
        '邹小安代养场',
        '彭盛文代养场',
        '葛松和代养场',
        '孙浩然一场',
        '李建军一场',
        '李建军二场',
        '许德强代养场',
        '孙浩然二场',
        '徐梦梦代养场',
        '吴瑶代养场',
        '王国红代养场',
        '彭紫明代养场',
        '余启福代养场',
        '李春华代养场',
        '李日火代养场',
        '乔神义代养场',
        '郑飞代养场',
        '王亚雯代养场',
        '彭民良代养场',
        '罗时灿代养场',
        '黄桦代养场',
        '饶长仂代养场',
        '艾叶红代养场',
        '周建华代养场',
        '吴亮代养场',
        '谢俊代养场',
        '卢冬代养场',
        '江新荣代养场',
        '王慧高代养场',
        '李向坤代养场',
        '徐小敏代养场',
        '熊建平代养场',
        '余兰兰代养场',
        '邱强代养场',
        '彭新辉代养场',
        '黎敏代养场',
        '许娟华代养场',
        '李允代养场',
        '汪文科代养场',
        '许泽明代养场',
        '管斌代养场',
        '陈丽君代养场',
        '刘琼代养场',
        '何小建代养场',
        '钟声祥代养场',
        '刘伟国代养场',
        '肖娟代养场',
        '张梅生代养场',
        '赵林敏代养场',
        '彭河山代养场',
        '何炳凡代养场',
        '李春华二场',
        '蔡珩代养场',
        '袁国娇代养场',
        '何晓东代养场',
        '付士安代养场',
        '刘志斌代养场',
        '聂小洪代养场',
        '张良标代养场',
        '谌威代养场',
        '刘强代养场',
        '王亚雯二场',
        '钟志勇代养场',
        '徐德林代养场',
        '黄飞代养场',
    ],
    sizhu: [
        '正康育肥场', 
        '平望母猪场', 
        '下水碓育肥场', 
        '金雪珍代养场',
        '余金泉代养场',
        '臧鹏飞代养场',
        '方新华代养场',
        '姚勇汉代养场',
        '胡海英代养场',
        '陈细倪代养场',
        '向焱初代养场',
        '彭爱兰代养场',
        '周文雨代养场',
        '余玲玲代养场',
        '陈丹代养场',
        '徐珺珺代养场',
        '黄光明代养场',
        '张顺风代养场',
        '尚喜峰代养场',
        '乔迟来代养场',
        '彭高山代养场',
        '江海英代养场',
        '林德文代养场',
        '程雨忠代养场',
        '邹小安代养场',
        '彭盛文代养场',
        '葛松和代养场',
        '孙浩然一场',
        '李建军一场',
        '李建军二场',
        '许德强代养场',
        '孙浩然二场',
        '徐梦梦代养场',
        '吴瑶代养场',
        '王国红代养场',
        '彭紫明代养场',
        '余启福代养场',
        '李春华代养场',
        '李日火代养场',
        '乔神义代养场',
        '郑飞代养场',
        '王亚雯代养场',
        '彭民良代养场',
        '罗时灿代养场',
        '黄桦代养场',
        '饶长仂代养场',
        '艾叶红代养场',
        '周建华代养场',
        '吴亮代养场',
        '谢俊代养场',
        '卢冬代养场',
        '江新荣代养场',
        '王慧高代养场',
        '李向坤代养场',
        '徐小敏代养场',
        '熊建平代养场',
        '余兰兰代养场',
        '邱强代养场',
        '彭新辉代养场',
        '黎敏代养场',
        '许娟华代养场',
        '李允代养场',
        '汪文科代养场',
        '许泽明代养场',
        '管斌代养场',
        '陈丽君代养场',
        '刘琼代养场',
        '何小建代养场',
        '钟声祥代养场',
        '刘伟国代养场',
        '肖娟代养场',
        '张梅生代养场',
        '赵林敏代养场',
        '彭河山代养场',
        '何炳凡代养场',
        '李春华二场',
        '蔡珩代养场',
        '袁国娇代养场',
        '何晓东代养场',
        '付士安代养场',
        '刘志斌代养场',
        '聂小洪代养场',
        '张良标代养场',
        '谌威代养场',
        '刘强代养场',
        '王亚雯二场',
        '钟志勇代养场',
        '徐德林代养场',
    ],
    siliao:[
        '全部',
        '华昇饲料',
        '仙居饲料',
        '丽水饲料',
        '正大饲料',
        '兰溪饲料',
        '兰溪市绿发饲料有限公司',
        '鹰潭新希望饲料有限公司',
        '江西高安大北农饲料有限公司',
        '景德镇大北农生物科技有限公司',
        '江西新希望农牧科技有限公司',
        '新余海合生物科技有限公司',
        '信丰双胞胎饲料有限公司',
        '赣州加大饲料有限公司 '
    ],
    org: [
        '全部',
        '义乌华昇牧业有限公司',
        '正康（义乌）猪业有限公司',
        '东阳华统牧业有限公司',
        '浦江华统牧业有限公司',
        '兰溪华统牧业有限公司',
        '衢州华统牧业有限公司',
        '丽水市丽农生态农牧有限公司',
        '仙居华统种猪有限公司',
        '仙居绿发生态农业有限公司',
        '天台华统牧业有限公司',
        '乐清市华统牧业有限公司',
        '杭州同壮农业发展有限公司',
        '浙江华昇饲料科技有限公司',
        '仙居县绿发饲料有限公司',
        '丽水市绿生源饲料有限公司',
        '浙江绿发饲料科技有限公司',
        '浙江绿发农牧机械有限公司',
        '义乌市绿发农业开发有限公司',
        // '浙江华统肉制品股份有限公司',
        // '浙江华统肉制品股份有限公司-鲜品本部',
        // '浙江华统肉制品股份有限公司-肉品部',
        // '浙江华统肉制品股份有限公司-生猪采购部',
        '华统股份-养殖事业部',
        '华统股份-鲜品事业部',
        '华统股份-肉品事业部',
        '华统股份-职能部',
        
        '义乌华农家禽屠宰有限公司',
        '苏州市华统食品有限公司',
        '衢州市民心食品有限公司 ',
        '湖州南浔华统肉制品有限公司',
        '台州市路桥区商业有限公司',
        '缙云县华昇食品有限责任公司',
        '台州华统食品有限公司',
        '苍南县华统食品有限公司',
        '建德市政新食品有限公司',
        '仙居县广信食品有限公司',
        '兰溪市丽农食品有限公司',
        '天台华统食品有限公司',
        '浙江省东阳康优食品有限公司',
        '金华市江北畜禽屠宰服务有限公司',
        '浦江县六和食品有限责任公司',
        '丽水市华统食品有限公司',
        '宁海县华统食品有限公司',
        '杭州临安深山坞里肉类有限公司',
        '海宁市华统食品有限公司',
        '湖北华统蕙民食品有限公司',
        '邵阳市华统食品有限公司 ',
        '梨树县华统食品有限公司',
        '绩溪县华统食品有限公司',
        '九江浔成肉类联合加工有限公司',
        '浙江禾壮肥料有限公司',
        '华统餐饮配送（浙江）有限公司',
        '兰溪市绿发饲料有限公司',
        '衢州市瀚荣农业开发有限公司', 
        '黄山华徽食品有限公司',
        '萍乡华盛牧业有限公司',
        '外部车辆',
    ],
    you: [
        '全部',
        '场外加油站',
        '义乌平望猪场油罐', 
        '义乌下水碓猪场油罐', 
        '义乌正康猪场油罐', 
        '义乌正康洗消中心油罐',
        '东阳猪场油罐',
        '浦江猪场油罐',
        '兰溪瑞溪猪场油罐',
        '兰溪百凤林猪场油罐',
        '衢州张村猪场油罐',
        '衢州莲花猪场油罐',
        '衢州横路猪场油罐',
        '丽水里塘猪场油罐',
        '丽水苍坑猪场油罐',
        '仙居三亩田猪场油罐',
        '仙居瓦垚头猪场油罐',
        '仙居下各猪场油罐（二级站）',
        '仙居下各猪场油罐（洗消中心）',
        '天台猪场油罐',
        '乐清猪场油罐',
        '杭州同壮猪场油罐（污水区）',
        '杭州同壮猪场油罐（场内）',
        '义乌华昇饲料油罐',
        '仙居饲料公司油罐',
        '丽水绿生源饲料油罐',
        '义乌华农家禽油罐',
        '苏州华统食品油罐',
        '台州华统食品油罐',
        '兰溪饲料油罐',
    ],
    huanbao: [
        '全部',
        '义乌正康猪场', 
        '义乌平望猪场', 
        '义乌下水碓猪场', 
        '仙居三亩田猪场', 
        '仙居下各猪场',
        '仙居瓦垚头猪场',
        '衢州莲花猪场',
        '衢州张村猪场',
        '衢州横路猪场',
        '里塘猪场',
        '苍坑猪场',
        '天台猪场',
        '建德猪场',
        '浦江猪场',
        '东阳猪场',
        '乐清猪场',
        '兰溪瑞溪猪场',
        '兰溪百凤林猪场',
    ],
    danwei: [
        '正康猪业',
        '华昇牧业', 
        '仙居种猪', 
        '仙居绿发', 
        '衢州华统', 
        '丽水丽农', 
        '天台华统', 
        '杭州同壮', 
        '浦江牧业', 
        '东阳牧业', 
        '东阳牧业', 
        '乐清牧业', 
        '兰溪牧业', 
        '衢州市瀚荣农业开发有限公司',
    ],
    bumen: [
        '生产（猪场）',
        '一级中转站',
        '二级中转站',
        '洗消中心',
        '污水站',
        '区域办公室',
        '总部'
    ],

    shitang: [
        '康师傅袋装方便面',
        '香飘飘 杯装各口味',
        '雀巢咖啡1+2微研磨',
        '维维豆奶760g',
        '白象方便面',
        '伊利全家高钙营养奶粉400g',
        '莫小仙煲仔饭265g',
        '芝麻糊',
        '皇味600g营养麦片原味',
        '智力320g原味豆浆粉A',
        '智力320g黑豆豆浆粉A',
        '智力400g纯藕粉无糖',
        '西麦原味牛奶燕麦片',
        '智力510g豆奶粉五黑',
        '西麦1kg燕麦',
        '海底捞自热火锅大',
        '海底捞自热火锅小',
        '湘菜诱惑自热火锅牛肉味',
        '合味道泡面',
        '鲁花压榨玉米油900ML',
        '金乐源五常大米5kg(红袋)',
        '泡面拍档',
        '王中王350g',
        '干脆面',
        '三只松鼠 牛肉干',
        '三只松鼠 猪肉脯',
        '三只松鼠 每日坚果750g',
        '三只松鼠 草莓干',
        '三只松鼠 芒果干',
        '三只松鼠 蔓越梅干',
        '三只松鼠 黄桃干',
        '三只松鼠 菠萝干',
        '三只松鼠 紫薯干',
        '三只松鼠 果单皮',
        '三只松鼠 山楂棒',
        '米老头满嘴香青裸米棒150g',
        '旺旺仙贝',
        '旺旺雪饼',
        '维达抽纸',
        '黑魔方面巾纸',
        '奥妙洗衣液',
        '黑人双重薄荷225G牙膏',
        '六神喷雾花露水180g',
        '力士沫浴乳(幽莲魅肤)特惠装900G',
        '冷酸灵炭旋转护敏牙刷1130',
        '飘柔滋润去屑洗发露930ml优惠装',
        '欧贝斯控油蓬松丰盈洗发露',
        '洁丽雅毛巾',
        '潘婷洗发露750ML',
        '安安国际浪漫樱花滋润沐浴露',
        '美加净沐浴露',
        '力士气泡透明沐浴露白桃香',
        '蓝月亮洗衣液3kg',
        '蓝月亮洗手液500g',
        '道地肠',
        '原味肠',
        '红牛',
        '旺仔',
        '安慕希酸奶',
        '伊利纯牛奶',
        '伊利优酸乳',
        '美汁源450',
        '加多宝',
        '可乐500ml',
        '可乐330ml',
        '雪碧500ml',
        '雪碧330ml',
        '苹果醋',
        '芬达',
        '娃哈哈八宝粥',
        '农夫山泉',
        '李子园',
        '双柚汁',
        '椰树椰汁',
        '特伦苏',
        '青柠汁',
        '娃哈哈ad钙奶',
        '蜜谷果汁（杯装）',
        '冬瓜汁',
        '元气森林 气泡水',
        '农夫山泉水溶C100',
        '汇源果汁',
        '娃哈哈纯净水',
        '东鹏特饮 24*500m1',
        '原味安慕希酸奶',
        'if椰子水350ml*24',
        '外星人电解质水',
        '三得利乌龙茶',
        '娃哈哈苏打水',
        '娃哈哈100ml乳酸菌奶',
        '营养快线',
        '娃哈哈龙井茶茉莉味低糖1升',
        '娃哈哈冰红茶柠檬味茶饮料1kg',
        '东方树叶无糖茉莉花茶',
        '兰芳园0蔗糖港式冻柠茶',
        '脉动青柠低糖饮料',
        '统一阿萨姆奶茶茉莉奶绿',
        '旺仔牛奶纸盒装',
        '蒙牛早餐奶',
        '茶π',
        '雪碧迷你罐',
        '安慕希草莓燕麦',
        '安慕希黄桃燕麦',
        '安慕希爆珠黄桃燕麦酸奶',
        '黄桃罐头',
        '椰果罐头',
        '咸肉'
    ],
    shitang2: [
        '水煮肉片',
        '洋葱炒牛肉',
        '黄焖鸡',
        '红烧猪蹄',
        '葱油大虾',
        '手抓扇子骨',
        '韭黄牛肉丝',
        '干菜肉末',
        '糯米蒸仔排',
        '卤牛肉',
        '开胃肚片',
        '红烧牛筋',
        '香辣鸡翅',
        '白切猪肝',
        '红烧鸡腿',
        '清蒸鸦片鱼头',
        '香辣牛蛙',
        '红烧带鱼',
        '捞汁小海鲜',
        '咖喱土豆鸡块',
        '爆炒鱿鱼',
        '土豆回锅肉',
        '黄飞鸿辣子鸡',
        '红烧大肠',
        '红烧大排',
        '剁椒鸦片鱼头',
        '红烧狮子头',
        '小鸡炖蘑菇',
        '土豆洋葱焖羊肉卷',
        '爆炒鸡肠',
        '香炒虎皮鸡爪',
        '香拌烤鸭',
        '酸菜鱼',
        '椒盐鸡翅',
        '芹菜牛肉丝',
        '麻辣回锅牛肉',
        '金汤肥牛',
        '三杯鸡',
        '芹菜鱿鱼丝',
        '红烧黄刺鱼',
        '糖醋里脊',
        '清蒸鲈鱼',
        '卤鸭头',
        '红烧鸡翅',
        '尖椒牛柳',
        '柠檬手撕鸡',
        '番茄牛腩',
        '嫩姜炒鸡',
        '可乐鸡翅',
        '豉香仔排',
        '椒盐小黄鱼',
        '野山椒牛肉丝',
        '葱油鲈鱼',
    ],
    shitang3: [
        '义乌本部(华农家禽)',
        '苏州华统食品有限公司',
        '湖州南浔华统肉制品有限公司',
        '台州华统食品有限公司',
        '丽水市华统食品有限公司',
        '衢州市民心食品有限公司',
        '梨树华统',
        '湖北蕙民华统',
        '邵阳华统',
        '苍南华统',
        '海宁市华统食品有限公司',
        '浙江省东阳康优食品有限公司',
        '台州市路桥商业有限公司',
        '仙居县广信食品有限公司',
        '天台华统食品有限公司',
        '建德市政新食品有限公司',
        '金华市江北畜禽屠宰服务有限公司',
        '兰溪市丽农食品有限公司',
        '浦江六和',
        '缙云县华昇食品有限责任公司',
        '绩溪县华统食品有限公司',
        '九江浔成',
        '正康禽业',
        '肉品部',
        '浙江华统肉制品股份有限公司总部食堂',
        '仙居禽业',
        '黄山华徽',
        '临安肉类'
    ],
}
